import React, { useEffect } from 'react'

const AloversaryPixleeWidget = ({ widgetPixleeId, apiKey }) => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://assets.pxlecdn.com/assets/pixlee_widget_1_0_0.js'
    script.async = true
    document.body.appendChild(script)

    window.PixleeAsyncInit = function () {
      window.Pixlee.init({ apiKey })
      window.Pixlee.addSimpleWidget({ widgetId: widgetPixleeId })
    }

    return () => {
      document.body.removeChild(script)
      delete window.PixleeAsyncInit
    }
  }, [widgetPixleeId, apiKey])

  return (
    <div className='aloversary-pixlee-widget'>
      <div className='section-container'>
        <h2>SHOP THE LOOK</h2>
        <p>Click the image to shop each item at ALO Yoga</p>
        <div id='pixlee_container' />
      </div>
    </div>
  )
}

export default AloversaryPixleeWidget
